export const contentfulSpaceId = process.env.CONTENTFUL_SPACE_ID || 'st43jm402pmo'
export const contentfulEnvironment = process.env.CONTENTFUL_ENVIRONMENT || 'master'
export const contentfulAccessToken = process.env.CONTENTFUL_ACCESS_TOKEN
export const contentfulPreviewAccessToken = process.env.CONTENTFUL_PREVIEW_ACCESS_TOKEN
export const contentfulManagementAccessToken = process.env.CONTENTFUL_MANAGEMENT_ACCESS_TOKEN
export const contentfulPreviewSecret = process.env.CONTENTFUL_PREVIEW_SECRET
export const algoliaAppId = process.env.NEXT_PUBLIC_ALGOLIA_APP_ID
export const algoliaSearchKey = process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY
export const algoliaIndexName = process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME || 'prod_ripplecom_nextjs'
export const algoliaRecommendedIndexName = 'recommended_searches';
